<template>

  <v-layout
    padless
  >
    <v-card
      flat
      tile
      color="footerback"
      class=" lighten-1 text-center"
      width="100%"

    >
    <v-card-text class="nk-footer">
      <v-row class="no-gutters pa-2">
        <v-col cols="12" class="mb-3">
          <img src="@/assets/logo-eaav-h.svg" alt="" width="200px">

        </v-col>
        <v-col cols="12">
          <v-btn
          v-for="(icon , idx) in icons"
          :key="'iconsocial-'+idx"
          class="mx-4"
          icon
          :href="icon.url"
          target="_blank"
        >
          <v-icon size="24px">{{ icon.icon }}</v-icon>
        </v-btn>
        </v-col>
        <v-col cols="12" class="my-2">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" sm="4" class="pa-3 mx-auto">
          <img src="@/assets/img/logo-icontec.png" width="80px" alt="Icontec">
        </v-col>
        <v-col cols="12" sm="4" class="text-left mx-auto pa-3">
          <ul class="text-pq">
            <h3 class="label-form"><strong>Empresa de Acueducto y Alcantarillado de Villavicencio EAAV</strong></h3>
            <li><strong>Sede Principal:</strong> Calle 39 Cra. 20 Barrio Paraiso, Villavicencio, Colombia</li>
            <li><strong>Horario de Atención:</strong> Lunes a Viernes 7:00 a.m - 03:00 p.m <br></li>
            <li><strong>Teléfono Conmutador:</strong>  <a href="tel:+576086818080">+57(608) 681 80 80</a></li>
            <li><strong>Línea Anticorrupción: 01 8000 91 2667</strong></li>
            <li><strong>Solicitudes y PQRD: </strong> <a href="https://stage.eaav.gov.co/tipo_pqrd">Hacer clic para realizar solicitud</a></li>
            <li><strong>Notificaciones Judiciales:</strong> articulo 197 de la Ley 1437 del 2011, para notificaciones estrictamente judiciales se autoriza el correo: <strong> notificacionesjuridica@eaav.gov.co</strong></li>
            <li><strong>Radicacion correspondencia: ventanillaunica@eaav.gov.co</strong></li>
            <li><strong>Canales de Atencion: </strong> <a href="https://www.eaav.gov.co/#/contenido/173/Canales%20de%20Atenci%C3%B3n">Ver todos</a></li>
          <!--  <li> <a href="https://www.eaav.gov.co/#/contenido/77/Políticas%20de%20Privacidad%20y%20Condiciones%20de%20Uso">Políticas de privacidad y condiciones de uso.</a></li> -->
      <!-- <li> <a href="https://www.eaav.gov.co/tipo_pqrd">Políticas Editoriales y de Actualización.</a></li> -->
            <v-divider class="my-2"></v-divider>
      <!--  <li><strong>Sede Comuna 8:</strong> Calle 19 Sur N°. 36 - 22 Barrio San Jorge lV</li>
            <li><strong>Horario de Atención:</strong> Lunes a Viernes 7:00 a.m. - 4:00 p.m</li> -->
       <!--     <li> <a href="https://www.eaav.gov.co/#/contenido/77/Políticas%20de%20Privacidad%20y%20Condiciones%20de%20Uso">Políticas de privacidad y condiciones de uso.</a></li> -->
       <!--     <li> <a href="https://www.eaav.gov.co/Mapa_sitio.htm">Mapa del Sitio</a></li> -->
          </ul>
        </v-col>
        <v-col cols="12" sm="4" class="text-left mx-auto pa-3">

          <p class="text-pq">

            Para una mejor experiencia, use las últimas versiones de Chrome, Firefox o Edge.
          </p>
        </v-col>
        <v-col cols="12" class="text-center my-3 cont-enlaces-footer">
          <a href="https://www.eaav.gov.co/#/contenido/77/Políticas%20de%20Privacidad%20y%20Condiciones%20de%20Uso">Políticas de privacidad y condiciones de uso</a>
          <span class="mx-4 separador-links">|</span>
          <a href="https://www.eaav.gov.co/Mapa_sitio.htm">Mapa del Sitio</a>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider light></v-divider>
    <v-toolbar
        color="#2470d0"
        height="40px"
        dark
        class="text-center d-flex justify-center align-center cont-menu-black">
        <a href="https://www.colombia.co/" target="_blank"><img src="@/assets/img/marcapais.png" width="40px" alt=""></a>
        <img src="@/assets/img/separator.png" width="40px" alt="">
        <a href="https://www.gov.co/" target="_blank"><img src="@/assets/img/marcapais-gov.svg" width="100px" alt=""></a>
    </v-toolbar>
    <v-card-text>
      {{ new Date().getFullYear() }} — <strong>www.eaav.gov.co</strong>
    </v-card-text>

    </v-card>
  </v-layout>

</template>

<script>
export default {
  data: () => ({
    icons: [
      {
        icon: 'fab fa-facebook',
        url: 'https://www.facebook.com/eaavesp/'
      },
      {
        icon: 'fab fa-instagram',
        url: 'https://www.instagram.com/eaavesp/'
      },
      {
        icon: 'fab fa-twitter',
        url: 'https://twitter.com/eaavesp'
      }, {
        icon: 'fab fa-youtube',
        url: 'https://www.youtube.com/channel/UCOlV55A_iGJFuwLSuisSfNQ'
      }
    ],
    dataFooter: [
    ]
  })
}
</script>
<style lang="scss">
@import '../scss/variables';

.nk-footer {
  width: 100vw;
}

/* 1. Estilo general para los textos y las listas del footer */
.text-pq {
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;
  font-size: 14px !important;
  color: #3e4444 !important;
  line-height: 1.8em !important;
  list-style-type: none !important;
  padding-left: 0 !important;
}

/* 2. Estilo para el título (Sencillo, sin negrita y conserva su azul original) */
.label-form {
  font-size: 16px !important;
  font-weight: normal !important;
  margin-bottom: 12px !important;
}

/* 3. Estilo para los enlaces/links */
.text-pq a {
  color: #1976d2 !important;
  text-decoration: none !important;
  font-weight: 500 !important;
}

.text-pq a:hover {
  text-decoration: underline !important;
}
</style>
